// extracted by mini-css-extract-plugin
module.exports = {"contextMenu":"notifications-menu_contextMenu_2asYo","link":"notifications-menu_link_3GfOs"};